import { axiosApi } from "../../../../../api/dbAxios";
import { INewNotification } from "../interfaces/notification.interface";

export const updateNotification = async (
  notif: Partial<INewNotification> & {
    id: number;
    regulators?: (number | INewNotification["regulators"][number])[];
  },
) => {
  try {
    const response = await axiosApi.patch(`/notifications/${notif.id}/`, notif);
    return response.data;
  } catch (error: any) {
    throw error.response.data;
  }
};
